import React, { useEffect, useState } from "react";
import { Container } from "./style";
import Input from "../../../../components/FormElement/Search";
import Button from "../../../../components/FormElement/Button";
import ImageUpload from "../../../../components/FormElement/ImageUpload";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHideModal } from "../../../../hooks";
import { useShowAlert } from "../../../../hooks/useAlerts";
import LangTab from "../../../../components/FormElement/LangTab";
import { useLocation } from "react-router-dom";
import service from "../../../../services/slider";
import Spinner from "../../../../components/Spinner/FullScreen";

export default ({ data, refreshData }) => {
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { hideModal } = useHideModal();
  const { error } = useShowAlert();
  const [fileList, setFileList] = useState([]);
  const [language, setLanguage] = useState("UZL");

  const validationSchema = Yup.object({
    title: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    desc: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    fileList: Yup.array().min(1).required("Kiritish shart!"),
  });

  const formik = useFormik({
    initialValues: {
      title: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      desc: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },

      fileList: [],
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("title[UZL]", values.title.UZL);
      formData.append("title[RUS]", values.title.RUS);
      formData.append("title[UZK]", values.title.UZK);
      formData.append("title[ENG]", values.title.ENG);
      formData.append("desc[UZL]", values.desc.UZL);
      formData.append("desc[RUS]", values.desc.RUS);
      formData.append("desc[UZK]", values.desc.UZK);
      formData.append("desc[ENG]", values.desc.ENG);
      fileList?.forEach((el) => {
        if (el.originFileObj) {
          formData.append(`file`, el.originFileObj);
        }
      });
      setLoading(true);
      if (data) {
        service
          .update(data, formData)
          .then(() => {
            hideModal();
            refreshData();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(formData)
          .then(() => {
            hideModal();
            refreshData();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
      hideModal();
      formik.resetForm();
      setIsEdit(false);
    },
  });

  useEffect(() => {
    if (data) {
      setLoading(true);
      setIsEdit(true);
      service
        .getOne(data)
        .then((resp) => {
          formik.setValues({
            title: {
              UZL: resp.title?.UZL,
              UZK: resp.title?.UZK,
              RUS: resp.title?.RUS,
              ENG: resp.title?.ENG,
            },
            desc: {
              UZL: resp.desc?.UZL,
              UZK: resp.desc?.UZK,
              RUS: resp.desc?.RUS,
              ENG: resp.desc?.ENG,
            },
          });
          resp?.photo && setFileList([resp?.photo]);
        })
        .catch((err) => {
          console.log(err);
          error(
            "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [state]);

  const onLangChange = (key) => {
    setLanguage(key);
  };

  useEffect(() => {
    formik.setFieldValue("fileList", fileList);
  }, [fileList]);

  if (loading) return <Spinner />;
  return (
    <Container>
      <form onSubmit={formik.handleSubmit}>
        <LangTab defaultActiveKey="1" onChange={onLangChange} />
        <Input
          id="title"
          name="title"
          label="Sarlavha"
          width={100}
          placeholder="Slayd sarlavhasi"
          onChange={(e) => {
            formik.setFieldValue(`title.${language}`, e.target.value);
          }}
          value={formik.values?.title[language]}
          status={formik?.errors?.title && formik.touched.title ? "error" : ""}
        />
        <Input
          id="desc"
          name="desc"
          label="Paragraf"
          width={100}
          placeholder="Slayd tavsifi"
          onChange={(e) => {
            formik.setFieldValue(`desc.${language}`, e.target.value);
          }}
          value={formik.values?.desc[language]}
          status={formik?.errors?.desc && formik.touched.desc ? "error" : ""}
        />

        <div className="upload-wrapper">
          <ImageUpload
            maxCount={1}
            multiple={true}
            fileList={fileList}
            setFileList={setFileList}
            status={
              formik?.errors?.fileList && formik.touched.fileList ? true : false
            }
          />
        </div>

        <Button
          text={isEdit ? "Tahrirlash" : "Saqlash"}
          htmlType="submit"
          width="100%"
        />
      </form>
    </Container>
  );
};
